import FixaButton from "../../../shared/wrappers/FixaButton/FixaButton";
import { Trans } from "@coworker/locales";

interface CreateMultiAddOnOrdersButtonProps {
  onClick: () => void;
  selectedArticlesCount?: number;
  disabled: boolean;
  createButtonText: string;
}

const CreateMultiAddOnOrdersButton = ({
  onClick,
  selectedArticlesCount,
  disabled,
  createButtonText,
}: CreateMultiAddOnOrdersButtonProps) => (
  <FixaButton
    text={<Trans count={selectedArticlesCount}>{createButtonText}</Trans>}
    type="primary"
    onClick={onClick}
    disabled={disabled}
    data-testid="createMultiOrdersButton"
  />
);

export default CreateMultiAddOnOrdersButton;
